/**
 * Отступы контролов плеера (как у PlayerFooterButton): через theme.spacing.
 */
export function playerFooterControlPadding(theme) {
  return {
    padding: theme.spacing(0.75),
    "@media (max-width: 450px)": {
      padding: theme.spacing(0.625),
    },
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(1.25),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(1.5),
    },
  };
}
